import { render, staticRenderFns } from "./ContentAppointment.vue?vue&type=template&id=345327b9&"
import script from "./ContentAppointment.vue?vue&type=script&lang=js&"
export * from "./ContentAppointment.vue?vue&type=script&lang=js&"
import style0 from "./ContentAppointment.vue?vue&type=style&index=0&id=345327b9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports